/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'6'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAP6000001',
    EAPZ000003: 'EAP6000003',
    EAPZ000004: 'EAP6000004',
    EAPZ000009: 'EAP6000009',
    EAPZ000010: 'EAP6000010',
    EAPZ000018: 'EAP6000018',
    EAPZ000019: 'EAP6000019',
    EAPZ000020: 'EAP6000020',
    EAPZ000050: 'EAP6000050',
    EAPZ000051: 'EAP6000051',
    EBAA000002: 'EBA6100002',
    EBAA000003: 'EBA6100003',
    EBAZ000015: 'EBA6000015',
    EIFA000001: 'EIF6100001',
    EIFA000002: 'EIF6100002',
    EIFA000003: 'EIF6100003',
    EIFA000004: 'EIF6100004',
    EIFA000005: 'EIF6100005',
    EIFA000006: 'EIF6100006',
    EIFA000007: 'EIF6100007',
    EIFA000008: 'EIF6100008',
    EIFA000009: 'EIF6100009',
    EIFA000011: 'EIF6100011',
    EIFA000012: 'EIF6100012',
    EIFA000013: 'EIF6100013',
    EIFA000014: 'EIF6100014',
    EIFA000015: 'EIF6100015',
    EIFA000016: 'EIF6100016',
    FDXZ000005: 'FDX6000005',
    FIFA000001: 'FIF6100001',
    // ここから画面固有
    EAPZ000027: 'EAP6000027',
    EBAA000028: 'EBA6100028',
    EBAZ000023: 'EBA6000023',
    EBAZ000078: 'EBA6000078',
    EBAZ000096: 'EBA6000096',
    EBAZ000097: 'EBA6000097',
    EBAZ000098: 'EBA6000098',
    EBAZ000106: 'EBA6000106',
    EBAZ000143: 'EBA6000143',
    EBAZ000145: 'EBA6000145',
    EBAZ000146: 'EBA6000146',
    EBAZ000147: 'EBA6000147',
    EBAZ000149: 'EBA6000149',
    EBAZ000151: 'EBA6000151',
    EBAZ000155: 'EBA6000155',
    EBAZ000157: 'EBA6000157',
    EBAZ000159: 'EBA6000159',
    EBAZ000160: 'EBA6000160',
    EBAZ000161: 'EBA6000161',
    EBAZ000162: 'EBA6000162',
    EBAZ000163: 'EBA6000163',
    EBAZ000164: 'EBA6000164',
    EBAZ000165: 'EBA6000165',
    EBAZ000189: 'EBA6000189',
    EBAZ000190: 'EBA6000190',
    EBAZ000191: 'EBA6000191',
    EBAZ000192: 'EBA6000192',
    EBAZ000193: 'EBA6000193',
    EBAZ000194: 'EBA6000194',
    EBAZ000195: 'EBA6000195',
    EBAZ000196: 'EBA6000196',
    EBAZ000197: 'EBA6000197',
    EBAZ000198: 'EBA6000198',
    EBAZ000246: 'EBA6000246',
    EBAZ000247: 'EBA6000247',
    EBAZ000248: 'EBA6000248',
    EBAZ000251: 'EBA6000251',
    EBAZ000252: 'EBA6000252',
    EBAZ000253: 'EBA6000253',
    EBAZ000254: 'EBA6000254',
    EBAZ000255: 'EBA6000255',
    EBAZ000256: 'EBA6000256',
    EBAZ000257: 'EBA6000257',
    EBAZ000258: 'EBA6000258',
    EBAZ000259: 'EBA6000259',
    EBAZ000260: 'EBA6000260',
    EBAZ000261: 'EBA6000261',
    EBAZ000262: 'EBA6000262',
    EBAZ000263: 'EBA6000263',
    EBAZ000264: 'EBA6000264',
    EBAZ000265: 'EBA6000265',
    EBAZ000266: 'EBA6000266',
    EBAZ000267: 'EBA6000267',
    EBAZ000268: 'EBA6000268',
    EBAZ000269: 'EBA6000269',
    EBAZ000270: 'EBA6000270',
    EBAZ000271: 'EBA6000271',
    EBAZ000298: 'EBA6000298',
    EBAZ000303: 'EBA6000303',
    EBAZ000304: 'EBA6000304',
    EBAZ000314: 'EBA6000314',
    EBAZ000315: 'EBA6000315',
    EBAZ000316: 'EBA6000316',
    EBAZ000367: 'EBA6000367',
    EBAZ000380: 'EBA6000380',
    EBAZ000384: 'EBA6000384',
    EBAZ000385: 'EBA6000385',
    EBAZ000386: 'EBA6000386',
    EBAZ000394: 'EBA6000394',
    EBAZ000396: 'EBA6000396',
    EBAZ000404: 'EBA6000404',
    EBAZ000406: 'EBA6000406',
    EBAZ000407: 'EBA6000407',
    EBAZ000408: 'EBA6000408',
    EBAZ000409: 'EBA6000409',
    EBAZ000410: 'EBA6000410',
    EBAZ000411: 'EBA6000411',
    EBAZ000413: 'EBA6000413',
    EBAZ000414: 'EBA6000414',
    EBAZ000416: 'EBA6000416',
    EBAZ000417: 'EBA6000417',
    EBAZ000418: 'EBA6000418',
    EBAZ000419: 'EBA6000419',
    EBAZ000421: 'EBA6000421',
    EBAZ000433: 'EBA6000433',
    EBAZ000434: 'EBA6000434',
    EBAZ000500: 'EBA6000500',
    EBAZ000520: 'EBA6000520',
    EBAZ000544: 'EBA6000544',
    EBAZ000584: 'EBA6000584',
    EBAZ000585: 'EBA6000585',
    EBAZ000587: 'EBA6000587',
    EBAZ000589: 'EBA6000589',
    EBAZ000596: 'EBA6000596',
    EBAZ000597: 'EBA6000597',
    EBAZ000615: 'EBA6000615',
    EBAZ000631: 'EBA6000631',
    EBAZ000638: 'EBA6000638',
    EBAZ000662: 'EBA6000662',
    EBAZ000674: 'EBA6000674',
    EBAZ000675: 'EBA6000675',
    EBAZ000676: 'EBA6000676',
    EBAZ000684: 'EBA6000684',
    EBAZ000707: 'EBA6000707',
    EBAZ000708: 'EBA6000708',
    EBAZ000709: 'EBA6000709',
    EBAZ000713: 'EBA6000713',
    EBAZ000722: 'EBA6000722',
    EBAZ000724: 'EBA6000724',
    EBAZ000727: 'EBA6000727',
    EBAZ000735: 'EBA6000735',
    EBAZ000736: 'EBA6000736',
    EBAZ000737: 'EBA6000737',
    EBAZ000738: 'EBA6000738',
    EBAZ000739: 'EBA6000739',
    EBAZ000745: 'EBA6000745',
    EBAZ000746: 'EBA6000746',
    EBAZ000747: 'EBA6000747',
    EBAZ000748: 'EBA6000748',
    EBAZ000749: 'EBA6000749',
    EBAZ000751: 'EBA6000751',
    EBAZ000752: 'EBA6000752',
    EBAZ000754: 'EBA6000754',
    EBAZ000755: 'EBA6000755',
    EBAZ000756: 'EBA6000756',
    EBAZ000767: 'EBA6000767',
    EBAZ000773: 'EBA6000773',
    EBAZ000778: 'EBA6000778',
    EBAZ000820: 'EBA6000820',
    EBAZ000822: 'EBA6000822',
    EBAZ000843: 'EBA6000843',
    EBAZ000846: 'EBA6000846',
    EBAZ000847: 'EBA6000847',
    EBAZ000848: 'EBA6000848',
    EBAZ000700: 'EBA6000700',
    EBAZ000702: 'EBA6000702',
    EBAZ000777: 'EBA6000777',
    ECLZ000001: 'ECL6000001',
    ECLZ000002: 'ECL6000002',
    ECLZ000003: 'ECL6000003',
    FOTO000001: 'FOT6000001',
    WBAZ000029: 'WBA6000029',
    WBAZ000030: 'WBA6000030',
    WBAZ000031: 'WBA6000031',
    WBAZ000032: 'WBA6000032',
    WBAZ000033: 'WBA6000033',
    WBAZ000034: 'WBA6000034',
    WBAZ000035: 'WBA6000035',
    WBAZ000036: 'WBA6000036',
    WBAZ000037: 'WBA6000037',
    WBAZ000038: 'WBA6000038',
    WBAZ000039: 'WBA6000039',
    WBAZ000040: 'WBA6000040',
    WBAZ000043: 'WBA6000043',
    WBAZ000044: 'WBA6000044',
    WBAZ000045: 'WBA6000045',
    WBAZ000048: 'WBA6000048',
    WBAZ000152: 'WBA6000152',
    WBAZ000198: 'WBA6000198',
    WBAZ000213: 'WBA6000213',
    WBAZ000214: 'WBA6000214',
    WBAZ000218: 'WBA6000218',
    WBAZ000219: 'WBA6000219',
    WBAZ000223: 'WBA6000223',
    WBAZ000224: 'WBA6000224',
    WBAZ000225: 'WBA6000225',
    WBAZ000226: 'WBA6000226',
    WBAZ000238: 'WBA6000238',
    WBAZ000239: 'WBA6000239',
    WBAZ000241: 'WBA6000241',
    WBAZ000242: 'WBA6000242',
    WBAZ000253: 'WBA6000253',
    WBAZ000254: 'WBA6000254',
    WBAZ000257: 'WBA6000257',
    WBAZ000355: 'WBA6000355',
    WBAZ000389: 'WBA6000389',
    WBAZ000428: 'WBA6000428',
    WBAZ000556: 'WBA6000556',
    WBAZ000557: 'WBA6000557',
    WBAZ000558: 'WBA6000558',
    WBAZ000562: 'WBA6000562',
    WBAZ000563: 'WBA6000563',
    WBAZ000564: 'WBA6000564',
    WBAZ000573: 'WBA6000573',
    WBAZ000577: 'WBA6000577',
    WBAA100012: 'WBA6100012',
    EBAA000029: 'EBA6100029',
    EBAA000030: 'EBA6100030',
    EBAA000037: 'EBA6100037',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'SNJ',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'KMI6J08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'KMI6J08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'KMI6J08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'numberic' as 'alphaNumberic' | 'numberic',
    length: 12,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 12,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: true,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: true,
  LOGO_FILE_PATH: 'assets/images/logo_snj.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_snj_biz.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000008]: 'EA024',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EIFA000012]: 'EA021',
    [ErrorCodeConstants.ERROR_CODES.EIFA000013]: 'EA021',
    [ErrorCodeConstants.ERROR_CODES.EIFA000014]: 'EA020',
    [ErrorCodeConstants.ERROR_CODES.EIFA000015]: 'EA018',
    [ErrorCodeConstants.ERROR_CODES.EIFA000016]: 'EA025',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA019', // ifly接続エラー(想定外エラー)
  } as { [key: string]: string },
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  // 画像の定数一覧
  IMG: {
    LOGO_S: 'assets/images/logo_snj_s.svg',
    LOGO_BIZ: 'assets/images/logo_snj_biz.svg',
    LOGO_S_WIDTH: '76',
    LOGO_S_HEIGHT: '22',
    LOGO_BIZ_WIDTH: '76',
    LOGO_BIZ_HEIGHT: '22',

    // ツールチップ
    ICON_HELP: 'assets/images/icon_help_snj_green_20.svg',

    // S01-P010-S01-U: 予約検索画面
    S01_P010_S01_U_XXX: '',

    // S01-P020-S01-U: 予約一覧画面
    S01_P020_S01_U_XXX: '',
    S01_P020_S01_U__ICON__ERROR_TRI_20: `assets/images/icon_error_tri_snj_red_dark_20.svg`,
    S01_P020_S01_U__ICON__LINK_PRIMARY_20: `assets/images/icon_link_snj_green_20.svg`,

    // S01-P030-S01-U: 予約詳細画面
    S01_P030_S01_U_XXX: '',

    // S01-P031-S01-U: 予約詳細(旅程)画面
    S01_P031_S01_U_XXX: '',
    S01_P030_S01_U__LINK: 'assets/images/icon_link_snj_green_20.svg',
    S01_P030_S01_U__PLANE_ACTIVE: 'assets/images/icon_plane_line_snj_green_32.svg',
    S01_P030_S01_U__AVATOR_ACTIVE: 'assets/images/icon_avator_snj_green_32.svg',
    S01_P030_S01_U__CHECKIN_SEAT_ACTIVE: 'assets/images/icon_checkin_seat_snj_green_32.svg',
    S01_P030_S01_U__TOOLTIP: 'icon_help_snj_green_20.svg',
    S01_P030_S01_U__ANOTHER_WINDOW: 'assets/images/icon_external_snj_green_16.svg',
    S01_P030_S01_U__Wifi_AVAILABLE: '',
    S01_P030_S01_U__Wifi_NOT_AVAILABLE: '',
    S01_P030_S01_U__Wifi_POSSIBLY_AVAILABLE: '',

    // S01-P032-S01-U: 予約詳細(搭乗者)画面
    S01_P032_S01_U_XXX: '',

    // S01-P033-S01-U: 予約詳細(サービス)画面
    S01_P033_S01_U_XXX: '',

    // S02-P013-S01-U: ジュニアパイロット申込画面
    S02_P013_S01_U_XXX: '',

    // S03-P010-S01-U: シートマップ画面
    S03_P010_S01_U_XXX: '',
    S03_P010_S01_U__SEATMAP__SEATMAP_AISLE_SHORT: `assets/images/seatmap_aisle_short.svg`,
    S03_P010_S01_U__SEGMENTS__ICON_CHECK_PRIMARY_20: `assets/images/icon_check_snj_green_20.svg`,
    S03_P010_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16: `assets/images/icon_external_snj_green_16.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_LEFT_40: `assets/images/btn_arrow_circle_left_40.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_RIGHT_40: `assets/images/btn_arrow_circle_right_40.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_DETAIL: `不使用`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_SEATTYPE: `assets/images/seatmap_float_seattype_snj.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_LEGEND: `assets/images/seatmap_float_legend_snj.svg`,
    S03_P010_S01_U__SEAT_EXITDOOR: `assets/images/seat_exitdoor_snj.svg`,
    S03_P010_S01_U__SEAT_FREE_SEAT_24: `assets/images/seat_snj_seat_24.svg`,
    S03_P010_S01_U__SEAT_BACK_SEAT_24: `assets/images/seat_back_seat_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_SEAT_24: `assets/images/seat_emergency_exit_seat_snj_24.svg`,
    S03_P010_S01_U__SEAT_UNAVAILABLE_24: `assets/images/seat_unavailable_24.svg`,
    S03_P010_S01_U__SEAT_INFANT_24: `assets/images/seat_infant_24.svg`,
    S03_P010_S01_U__SEAT_SELECTED_24: `assets/images/seat_selected_snj_24.svg`,
    S03_P010_S01_U__SEAT_BEFORE_CHANGE_FREE_SEAT_24: `assets/images/seat_before_change_free_seat_snj_24.svg`,
    S03_P010_S01_U__SEAT_UNCHANGEABLE_24: `assets/images/seat_unchangeable_snj_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW_24: `assets/images/seat_no_window_snj_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW: `assets/images/seat_no_window_snj.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINING_24: `assets/images/seat_no_reclining_snj_24.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINE: `assets/images/seat_no_recline_snj.svg`,
    S03_P010_S01_U__SEAT_TABLE_24: `assets/images/seat_table_24.svg`,
    S03_P010_S01_U__SEAT_LAVATORY_24: `assets/images/seat_lavatory_snj_24.svg`,
    S03_P010_S01_U__SEAT_MULTI_PURPOSE_ROOM_24: `assets/images/seat_multi_purpose_room_24.svg`,
    S03_P010_S01_U__SEAT_AISLE_24: `assets/images/seat_aisle_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_24: `assets/images/seat_emergency_exit_24.svg`,
    S03_P010_S01_U__SEAT_WING_24: `assets/images/seat_wing_snj_24.svg`,
    S03_P010_S01_U__SEAT_GALLEY_24: `assets/images/seat_galley_snj_24.svg`,
    S03_P010_S01_U__SEAT_PARTITION_24: `assets/images/seat_partition_24.svg`,
    S03_P010_S01_U__SEAT_BAR_24: `assets/images/seat_bar_24.svg`,
    S03_P010_S01_U__SEAT_STAIR_24: `assets/images/seat_stair_24.svg`,
    S03_P010_S01_U__SEAT_BASSINET_24: `assets/images/seat_bassinet_24.svg`,

    // S03-P020-S01-U: 座席属性指定画面
    S03_P020_S01_U_XXX: '',

    // S03-P030-S01-U: シートマップ（参照）画面
    S03_P030_S01_U_XXX: '',

    // S04-P010-S01-U: 搭乗者情報入力画面
    S04_P010_S01_U_XXX: '',

    // S05-P011-S01-U: 領収書選択画面
    S05_P011_S01_U_XXX: '',

    // S05-P020-S01-U: 搭乗証明書検索画面
    // TODO: 定数が確定するまでの暫定です
    S05_P020_S01_U_XXX: '',
    S05_P020_S01_U__TOOLTIP: 'assets/images/icon_help_snj_green_24.svg',
  },

  // 定数一覧
  CARRIER: {
    TWO_LETTER: '6J',
    // 提携: 利用時要確認（https://asy-pd.backlog.com/view/SMDI_137-2195）
    THREE_LETER: '',
  },

  //オフィス
  OFFICE: {
    OFFICE_CODE_WEB: 'KMI6J08SS', //WEB社用オフィス
  },
} as const;
